<template>
  <svg
    class="xpz-svg-icon"
    viewBox="0 0 1024 1024"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M586.624 234.624a74.624 74.624 0 1 1-149.184 0 74.624 74.624 0 0 1 149.12 0z m0 554.624a74.624 74.624 0 1 1-149.248 0 74.624 74.624 0 0 1 149.248 0zM512 586.624a74.624 74.624 0 1 0 0-149.248 74.624 74.624 0 0 0 0 149.248z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {
  name: "IconMore",
};
</script>

<style scoped>
.xpz-svg-icon {
  display: block;
  width: 1em;
  height: 1em;
}
</style>
